module.exports = __webpack_public_path__ + "img/logo-saas.d2fd2b01.png";